jQuery(document).ready(function(){
  jQuery("h6.offert").click(function(){
    jQuery(".product__info").slideToggle();
  });
});
